module.exports = __webpack_public_path__ + "static/media/book_nongenre_spine.4efc24d3.png";